import request from "@/utils/request1";
import baseURL from "@/utils/baseUrl1";

 const personService = {}
 let base_url = baseURL.person


// 举报提交
personService.reportsub = function (params) {
    return request ({
        url: '/v1/report',
        method: 'post',
        baseURL: base_url,
        data: params
    })
}
// 获取验证码
personService.queryphone = function (phone) {
    return request ({
        url: `/v1/send/code?phone=${phone}`,
        method: 'get',
        baseURL: base_url,
    })
}

personService.updatereport = function (params) {
    return request ({
        url: '/v1/report/update/'+params.id,
        method: 'put',
        baseURL: base_url,
        data: params
    })
}
 export default personService